import { render, staticRenderFns } from "./drugDetail.vue?vue&type=template&id=4561f690&scoped=true&"
import script from "./drugDetail.vue?vue&type=script&lang=js&"
export * from "./drugDetail.vue?vue&type=script&lang=js&"
import style0 from "./drugDetail.vue?vue&type=style&index=0&id=4561f690&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4561f690",
  null
  
)

export default component.exports